/* eslint-disable import/prefer-default-export */
import {
  LOGIN,
  ACCOUNT_SETUP,
  LOGOUT,
  PATH,
  WYR,
  RECOVER_PASSWORD,
  NEW_PASSWORD,
  ACCESS_DENIED,
  TEST,
  DEVELOPMENT,
  SL_COMPONENTS,
  EXPERIENCE_TRACKING_SUPERVISOR,
  ONBOARDING,
  EVENTS,
  CLAIM_STUDENT,
  CLAIM_ACCOUNT,
  LOCALHOST_LOGIN,
  PROGRAM_EXPLORATION,
  EVENT_SCHEDULER,
  GUARDIAN_ILP_APPROVAL,
  PLANS,
  CANDIDATE_SOURCED,
  PUBLIC_PLACEMENT,
  IPDB_INTAKE,
} from 'routes/constants';

export const ROUTES_WITHOUT_REDIRECTION = [
  LOGIN,
  ACCOUNT_SETUP,
  LOGOUT,
  PATH,
  WYR,
  RECOVER_PASSWORD,
  NEW_PASSWORD,
  ACCESS_DENIED,
  TEST,
  DEVELOPMENT,
  SL_COMPONENTS,
  EXPERIENCE_TRACKING_SUPERVISOR,
  ONBOARDING,
  EVENTS,
  CLAIM_STUDENT,
  CLAIM_ACCOUNT,
  LOCALHOST_LOGIN,
  PROGRAM_EXPLORATION,
  EVENT_SCHEDULER,
  GUARDIAN_ILP_APPROVAL,
  PLANS,
  CANDIDATE_SOURCED,
  PUBLIC_PLACEMENT,
  IPDB_INTAKE,
];
